import { setShowDirectoryModal } from '../State/showDirectoryModal';

export default () => async (dispatch) => {

  dispatch(setShowDirectoryModal(false));
  
}